import React from "react";
type BrandProps = {
  compact?: boolean;
};
export function Brand({
  compact = false
}: BrandProps) {
  return <a href="#inicio" className={`flex items-center gap-[11px] font-display font-extrabold tracking-[-1px] text-fg ${compact ? "text-[17px]" : "text-lg sm:text-[23px]"}`} data-id="element-15" data-mp="16bbxt2d8u0q9">
      <b className={`inline-flex items-center justify-center rounded-[10px] bg-lime text-bg ${compact ? "h-7 w-7 text-[22px]" : "h-[30px] w-[30px] text-[24px] sm:h-[35px] sm:w-[35px] sm:text-[27px]"}`} aria-hidden="true" data-id="element-16" data-mp="1fc1m7l06coty">
        R
      </b>
      Radar Digital
      {!compact && <small className="ml-[5px] hidden border-l border-[#42493e] pl-3 font-sans text-[11px] font-normal tracking-normal text-[#a4ab9e] lg:inline" data-id="element-17" data-mp="rm7ax7vi78bt">
          por Marcos Rosell
        </small>}
    </a>;
}